export const prepareHeadersBase = (headers: Headers) => {
    headers.set('Accept', 'application/json');
    headers.set('Content-Type', 'application/json');

    return headers;
};
